"use strict";

exports.__esModule = true;
exports.parseNationalInsurance = exports.parseInviteCode = exports.parseCurrency = void 0;

// Parse a curreny field as a decimal number
const parseCurrency = value => {
  if (!!value) {
    value = value.replace(/[^\d.]/g, '');

    if (value.indexOf('.') !== -1) {
      const decimals = value.split('.');
      value = `${decimals[0]}.${decimals[1].substring(0, 2)}`;
    }
  }

  return value;
};

exports.parseCurrency = parseCurrency;

const parseNationalInsurance = value => {
  if (!value) {
    return value;
  }

  return value.replace(/[^\da-zA-Z]/g, '').toUpperCase();
}; // Parse the invite code to remove the hyphen


exports.parseNationalInsurance = parseNationalInsurance;

const parseInviteCode = value => {
  if (!value) {
    return value;
  }

  return value.toUpperCase().replace(/[^\dA-Z]/g, '');
};

exports.parseInviteCode = parseInviteCode;